import { render } from "./BecomeAPilotMobile.vue?vue&type=template&id=fbad9b72&scoped=true"
import script from "./BecomeAPilotMobile.vue?vue&type=script&lang=js"
export * from "./BecomeAPilotMobile.vue?vue&type=script&lang=js"

import "./BecomeAPilotMobile.vue?vue&type=style&index=0&id=fbad9b72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbad9b72"]])

export default __exports__